
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'


export default {
components: {
Flexbox,
FlexboxItem,
},
data() {
return {}
},
created() {
},
mounted() {

},
methods: {
jump(index) {
let jumpUrl = ''
switch (index) {
case 1:
jumpUrl = this.$t('greenchannel.link1');
window.location.href = jumpUrl
break;
case 2:
jumpUrl = this.$t('greenchannel.link2');
window.location.href = jumpUrl
break;
case 3:
jumpUrl = this.$t('greenchannel.link3');
window.location.href = jumpUrl
break;
case 4:
jumpUrl = this.$t('greenchannel.link4');
window.location.href = jumpUrl
break;
case 5:
jumpUrl = this.$t('greenchannel.link5');
window.location.href = jumpUrl
break;
case 6:
jumpUrl = this.$t('greenchannel.link6');
window.location.href = jumpUrl
break;
case 7:
jumpUrl = this.$t('greenchannel.link7');
window.location.href = jumpUrl
break;
case 8:
jumpUrl = this.$t('greenchannel.link8');
window.location.href = jumpUrl
break;
case 9:
jumpUrl = this.$t('greenchannel.link9');
window.location.href = jumpUrl
break;
case 10:
jumpUrl = this.$t('greenchannel.link10');
window.location.href = jumpUrl
break;
case 11:
jumpUrl = this.$t('greenchannel.link11');
window.location.href = jumpUrl
break;
case 12:
jumpUrl = this.$t('greenchannel.link12');
window.location.href = jumpUrl
break;
case 13:
jumpUrl = this.$t('greenchannel.link13');
window.location.href = jumpUrl
break;
case 14:
jumpUrl = this.$t('greenchannel.link14');
window.location.href = jumpUrl
break;

default:
break;
}
}
}
}



// WEBPACK FOOTER //
// ./src/page/greenchannel/news.vue